import { render, staticRenderFns } from "./SdkReferensId.vue?vue&type=template&id=4c2f47a8&"
import script from "./SdkReferensId.vue?vue&type=script&lang=js&"
export * from "./SdkReferensId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2f47a8')) {
      api.createRecord('4c2f47a8', component.options)
    } else {
      api.reload('4c2f47a8', component.options)
    }
    module.hot.accept("./SdkReferensId.vue?vue&type=template&id=4c2f47a8&", function () {
      api.rerender('4c2f47a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/Metadata/SdkReferensId.vue"
export default component.exports